import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import NavigationColor from 'utils/constants/NavigationColor';

const NavItem = styled.li<{
  variant: NavigationColor.LIGHT | NavigationColor.DARK;
}>`
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${rem(14)};
  color: ${({ variant, theme }) =>
    variant === NavigationColor.LIGHT
      ? theme.neutralPalette.white
      : theme.brandPalette.dark};

  &:hover {
    cursor: pointer;
    color: ${({ variant, theme }) =>
      variant === NavigationColor.LIGHT
        ? theme.brandPalette.primary
        : theme.brandPalette.secondary};
  }

  .active {
    color: ${(props) => props.theme.brandPalette.primary};
  }
`;

interface NavigationItemProps {
  href: string;
  active?: boolean;
  children: React.ReactNode;
  variant: NavigationColor.LIGHT | NavigationColor.DARK;
}

const NavigationItem = ({
  href,
  children,
  variant,
  active,
}: NavigationItemProps) => {
  return (
    <NavItem variant={variant}>
      <a className={active ? 'active' : ''} href={href} target="_blank">
        {children}
      </a>
    </NavItem>
  );
};

export default NavigationItem;
